import React, { useState, useEffect } from "react";
import { Table, Tag, Spin, Empty, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import request from "utils/api";

const { Link } = Typography;

const statusColor = {
  new: "blue",
  shipped: "orange",
  success: "green",
  cancel: "red",
};

const statusLabel = {
  new: "Mới",
  shipped: "Đang giao",
  success: "Thành công",
  cancel: "Đã huỷ",
};

const VoucherUsageExpand = ({ record }) => {
  const navigate = useNavigate();
  const [usages, setUsages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUsages = async () => {
      try {
        const res = await request(
          `api/fonehouse/voucher/${record._id}/usages`,
          {},
          { method: "GET" }
        );
        setUsages(res?.data || []);
      } catch (err) {
        setUsages([]);
      } finally {
        setLoading(false);
      }
    };
    fetchUsages();
  }, [record._id]);

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: 24 }}>
        <Spin size="small" />
      </div>
    );
  }

  if (!usages.length) {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description="Chưa có ai sử dụng voucher này"
        style={{ padding: 16 }}
      />
    );
  }

  const columns = [
    {
      title: "Khách hàng",
      key: "user",
      render: (_, row) => {
        const user = row.userId;
        if (!user) return "--";
        return (
          <div>
            <div style={{ fontWeight: 500 }}>{user.name || "--"}</div>
            <div style={{ fontSize: 12, color: "#999" }}>
              {user.phone || user.email || ""}
            </div>
          </div>
        );
      },
    },
    {
      title: "Đơn hàng",
      key: "order",
      render: (_, row) => {
        const order = row.orderId;
        if (!order) return "--";
        return (
          <Link
            onClick={() =>
              navigate(`/fonehouse/billing_list/${order._id}`)
            }
            style={{ cursor: "pointer" }}
          >
            {order.identity || `#${order.orderId}`}
          </Link>
        );
      },
    },
    {
      title: "Trạng thái đơn",
      key: "orderStatus",
      render: (_, row) => {
        const status = row.orderId?.status;
        if (!status) return "--";
        return (
          <Tag color={statusColor[status] || "default"}>
            {statusLabel[status] || status}
          </Tag>
        );
      },
    },
    {
      title: "Giảm giá",
      dataIndex: "discountAmount",
      key: "discountAmount",
      render: (val) => (
        <span style={{ color: "#f5222d", fontWeight: 500 }}>
          -¥{(val || 0).toLocaleString()}
        </span>
      ),
    },
    {
      title: "Ngày sử dụng",
      dataIndex: "usedAt",
      key: "usedAt",
      render: (date) =>
        date ? moment(date).format("HH:mm DD/MM/YYYY") : "--",
    },
  ];

  return (
    <div style={{ padding: "8px 16px" }}>
      <div style={{ marginBottom: 8, fontWeight: 500 }}>
        Lịch sử sử dụng ({usages.length})
      </div>
      <Table
        columns={columns}
        dataSource={usages}
        rowKey={(row) => row._id}
        pagination={false}
        size="small"
        bordered
      />
    </div>
  );
};

export default VoucherUsageExpand;
